import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import { useAuth, dashboardPath } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Home from "@/pages/Home";
import ComeFunziona from "@/pages/ComeFunziona";
import PerBnb from "@/pages/PerBnb";
import PerBar from "@/pages/PerBar";
import Pacchetti from "@/pages/Pacchetti";
import DiventaPartner from "@/pages/DiventaPartner";
import Contatti from "@/pages/Contatti";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import RegisterBnb from "@/pages/RegisterBnb";
import RegisterVendor from "@/pages/RegisterVendor";
import GuestOrder from "@/pages/GuestOrder";
import OrderStatus from "@/pages/OrderStatus";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/dashboards/AdminDashboard";
import BnbDashboard from "@/pages/dashboards/BnbDashboard";
import VendorDashboard from "@/pages/dashboards/VendorDashboard";

function PublicLayout({ children }) {
  return (
    <div className="App flex flex-col min-h-screen bg-white">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function AuthCallback() {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/accedi"); return; }
    googleLogin(sid)
      .then((u) => { window.history.replaceState(null, "", window.location.pathname); navigate(dashboardPath(u.role)); })
      .catch(() => navigate("/accedi?google_error=1"));
  }, [googleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <Loader2 className="w-8 h-8 text-orange animate-spin" />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/come-funziona" element={<PublicLayout><ComeFunziona /></PublicLayout>} />
      <Route path="/per-bnb" element={<PublicLayout><PerBnb /></PublicLayout>} />
      <Route path="/per-bar" element={<PublicLayout><PerBar /></PublicLayout>} />
      <Route path="/pacchetti" element={<PublicLayout><Pacchetti /></PublicLayout>} />
      <Route path="/diventa-partner" element={<PublicLayout><DiventaPartner /></PublicLayout>} />
      <Route path="/contatti" element={<PublicLayout><Contatti /></PublicLayout>} />
      <Route path="/legal/:type" element={<PublicLayout><Legal /></PublicLayout>} />
      <Route path="/accedi" element={<Login />} />
      <Route path="/registra/bnb" element={<PublicLayout><RegisterBnb /></PublicLayout>} />
      <Route path="/registra/locale" element={<PublicLayout><RegisterVendor /></PublicLayout>} />
      <Route path="/ospite/:bnbId" element={<GuestOrder />} />
      <Route path="/ordine/:code" element={<OrderStatus />} />
      <Route path="/pagamento/successo" element={<PaymentSuccess />} />
      <Route path="/dashboard/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
      <Route path="/dashboard/bnb" element={<ProtectedRoute role="bnb"><BnbDashboard /></ProtectedRoute>} />
      <Route path="/dashboard/locale" element={<ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
